import type { ReactNode } from "react";
import { Link, type To } from "react-router-dom";

import styles from "./styles.module.css";

type BaseProps = {
  children: ReactNode;
  className?: string;
};

type LocalLinkProps = BaseProps & {
  to: To;
};

type ExternalLinkProps = BaseProps & {
  href: string;
};

type Props = LocalLinkProps | ExternalLinkProps;

function isLocal(props: Props): props is LocalLinkProps {
  return "to" in props;
}

function isExternal(props: Props): props is ExternalLinkProps {
  return "href" in props;
}

export default function NavLink(props: Props) {
  const className = [styles.navlink, props.className].filter(Boolean).join(" ");

  if (isLocal(props))
    return (
      <Link to={props.to} className={className}>
        {props.children}
      </Link>
    );

  if (isExternal(props))
    return (
      <a href={props.href} className={className}>
        {props.children}
      </a>
    );

  throw new Error("Invalid props");
}
